// Mirrors the legacy number_to_currency(unit: league.currency_symbol) rendering:
// symbol prefix, comma delimiter, league-driven precision (0 for Japanese customers).
//
// The 'en-US' locale is fixed on purpose — do not parameterize it. No locale
// file in config/locales/ overrides the number: formats, so the Rails side
// renders a comma delimiter and period separator for EVERY locale; that
// comma-grouping is the app-wide contract for money, and localizing it here
// would make this the only money display in the app that diverges from the
// server-rendered tables. Only symbol and precision vary, because they are
// league configuration, not viewer locale.
export const formatCurrency = (value, symbol = '$', decimalPlaces = 2) =>
  `${symbol}${Number(value).toLocaleString('en-US', {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  })}`;
